import React, { useState, useEffect, useContext } from "react";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import Form from "react-bootstrap/Form";
import { Editor } from "@tinymce/tinymce-react";
import AlertContext from "../../../../context/AlertContext";
import Radio from "../../../CommonComponents/Radio";
import Button from "../../../Button";
import UploadSvg from "../../../../Svg/UploadIconsvg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { TextField } from "@mui/material";
import useS3FileManagement from "../../../../Hooks/useS3FileManagement";
import constants, { RESULT_STATUS } from "../../../../constants";
import { emailBody, getDataFromStorage } from "../../../../util";
import { Offcanvas } from "react-bootstrap";
import Select from "react-select";
import { useParams } from "react-router-dom";

const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

const validators = {
  email: (v) =>
    !v?.trim()
      ? "Please enter the email"
      : !emailRegex.test(v)
        ? "Please enter the valid email"
        : "",
  fname: (v) =>
    !v?.trim()
      ? "First name is required"
      : /^[A-Za-z. ]+$/.test(v)
        ? "Please enter the valid first name"
        : "",
};

function UserDetails(props) {
  const { id } = useParams();

  // 0 = single/internal, 1 = multiple/external, 2 = batch evaluator
  const { getPreSignedUrl } = useS3FileManagement();
  const [selectedType, setSelectedType] = useState(
    [constants.Roles.trainer, constants.Roles.learner].includes(
      props.newUserInput.role,
    )
      ? 0
      : [constants.Roles.tutor].includes(props.newUserInput.role)
        ? 1
        : 2,
  );

  const {
    setIsLoaded,
    batchDetails,
    setBatchDetails,
    setShowNotify,
    setShow,
    setIsUnAuth,
    setMsg,
    setTitle,
    fromTrainer,
    setFromTrainer,
    isCCreator,
    setIsCCreator,
    isEditTC,
    setIsEditTC,
    companyInfo,
    isAdmin,
  } = useContext(AlertContext);

  const [isExistingUser, setIsExistingUser] = useState(false);
  const [userDetailByEmail, setUserDetailByEmail] = useState([]);
  const [companyNames, setCompanyNames] = useState(
    companyInfo.map((item) => ({ value: item.company_id, label: item.name })),
  );
  const [collegeList, setCollegeList] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState(
    props.newUserInput?.college ? props.newUserInput?.college : null,
  );
  const [selectedCompany, setSelectedCompany] = useState([]);
  const singleUsersRoles = [
    constants.Roles.learner,
    constants.Roles.tutor,
    constants.Roles.trainer,
    constants.Roles.evaluator,
    constants.Roles.creator,
    constants.Roles.admin,
    constants.Roles.hr,
    constants.Roles.super_admin,
  ];
  const [addSingleUser, setAddSingleUser] = useState(
    singleUsersRoles.includes(props.newUserInput.role),
  );
  // const [showUserFormPopup, setShowUserFormPopup] = useState(false);
  const [savebtnHide, setSavebtnHide] = useState(fromTrainer ? true : false);
  const axios = useAxiosPrivate();
  const [focusStates, setFocusStates] = useState(false);
  const [fileLoaded, setFileLoaded] = useState("");
  const [checkExistEmail, setCheckExistEmail] = useState({
    batchid: batchDetails.id,
    email: props.newUserInput.email,
    emailBody:
      "<p>We are glad to invite you to share the joy of learning and educating with Gradious.</p>",
    role: props.newUserInput.role,
    mobile: props.newUserInput.mobile,
    college: props.newUserInput.college,
    branch: props.newUserInput.branch,
    lastname: props.newUserInput.lastname,
  });

  const [userId, setUserId] = useState("");
  const [topics, setTopics] = useState([]);

  const isEdit = !isNaN(parseInt(userId));

  /* warning msg for role change */
  const [roleChangeInfo, setRoleChangeInfo] = useState(null);

  const handleResponse = (title, msg) => {
    setShowNotify({
      show: true,
      title: title,
      msg: msg,
    });
  };

  useEffect(() => {
    setUserId(props.newUserInput?.id);
  }, [props.newUserInput?.id]);

  useEffect(() => {
    if (!isNaN(parseInt(userId))) setSavebtnHide(true);
  }, [userId]);

  const handleInputChange = (e, field) => {
    // setSavebtnHide(true);
    if (!savebtnHide && isEdit) setSavebtnHide(true);
    if (field === "emailBody") {
      props.setNewUserInput({ ...props.newUserInput, [field]: e });
    } else if (field === "mobile") {
      props.setNewUserInput({ ...props.newUserInput, [field]: e });
      setUserDetailByEmail({ ...userDetailByEmail, [field]: e });
    } else if (field === "topic") {
      props.setNewUserInput({ ...props.newUserInput, topics: e });
    } else {
      let target = e.target;
      let name = target.name;
      let value = target.value;

      props.setNewUserInput({ ...props.newUserInput, [name]: value });
      setUserDetailByEmail({ ...userDetailByEmail, [name]: value });
    }
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    setSavebtnHide(true);
  };

  const handleClosePopup = () => {
    props.setShowUserFormPopup(false);
    setFromTrainer(false);
    setIsCCreator(false);
    setIsEditTC(false);
    props.setNewUserInput({
      batchid: batchDetails.id,
      emailBody: emailBody,
      role: props.newUserInput.role,
    });
  };

  useEffect(() => {
    if (props.newUserInput.role === constants.Roles.hr) {
      try {
        const responseOfColleges = async () => {
          let response = await axios.get("node/admin/batch/college", {
            params: {
              id: batchDetails?.id || id,
              email: props.newUserInput.email,
            },
            headers: { "Content-type": "application/json" },
          });
          const transformedData = response.data.data.map((item, index) => {
            return { label: item.name, value: index + 1 };
          });

          setCollegeList(transformedData);

          if (props.newUserInput?.college)
            setSelectedCollege({ label: props.newUserInput.college, value: 1 });
        };

        responseOfColleges();
      } catch (err) {
        if (err.message.includes("403")) {
          handleResponse(
            "Error",
            "You have been logged-out due to inactivity. Login again.",
          );
          setIsUnAuth(true);
        } else {
          handleResponse("Error", err.message);
        }
      }
    }
  }, []);

  const handleInputEmailChange = (e) => {
    if (!savebtnHide && isEdit) setSavebtnHide(true);
    let target = e.target;
    let name = target.name;
    let value = target.value;
    setCheckExistEmail({ ...checkExistEmail, [name]: value });
    props.setNewUserInput({ ...props.newUserInput, [name]: value });
  };

  const handleCreateUser = (event) => {
    event.preventDefault();

    let role = document.uservalidateForm.role?.value;
    let emailid = document.uservalidateForm.email?.value?.trim();
    let lname = document.uservalidateForm.lastname?.value;
    let fname = document.uservalidateForm.firstname?.value;
    let college = document.uservalidateForm.college?.value;
    let branch = document.uservalidateForm.branch?.value;
    let companyId = selectedCompany?.value;

    let newUserDetails = { ...props.newUserInput };
    newUserDetails.role = props.newUserInput.role;
    newUserDetails.companyAddId = companyId;

    if (newUserDetails.role === constants.Roles.hr) {
      newUserDetails.college = selectedCollege?.label;
    }

    if (role !== "") {
      if (fname !== "") {
        if (/^[A-Za-z. ]+$/.test(fname)) {
          if (/^[A-Za-z. ]+$/.test(lname) || lname === "") {
            if (emailid !== "") {
              if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailid)) {
                // if (props.newUserInput.role === constants.Roles.admin && !companyId) {
                //   return setShowNotify({
                //     show: true,
                //     title: "Warning !",
                //     msg: "Please select Company !",
                //   });
                // }
                if (
                  props.newUserInput.role === constants.Roles.hr &&
                  !selectedCollege?.label
                ) {
                  return setShowNotify({
                    show: true,
                    title: "Warning !",
                    msg: "Please select College !",
                  });
                }
                if (
                  /^[A-Za-z0-9.,&'’"()-/ ]+$/.test(college) ||
                  college === ""
                ) {
                  if (
                    /^[A-Za-z0-9.,&'’"()-/ ]+$/.test(branch) ||
                    branch === ""
                  ) {
                    setIsLoaded(true);
                    axios
                      .post(
                        "node/admin/batch/user/add",
                        JSON.stringify(newUserDetails),
                        {
                          headers: {
                            "Content-type": "application/json",
                          },
                        },
                      )
                      .then((res) => {
                        setIsLoaded(false);

                        if (res.data.resultCode === 1000) {
                          setShowNotify({
                            show: true,
                            title: "Info",
                            msg: res.data.data,
                          });
                          handleClosePopup();
                          // props.setAddUser(false);
                          props.refetch();
                        } else if (
                          res.data.resultCode === 2050 &&
                          res.data.msg.includes("Duplicate entry")
                        ) {
                          setShowNotify({
                            show: true,
                            title: "Warning !",
                            msg: "This email has already exists",
                          });
                        } else {
                          setIsLoaded(false);
                          setShowNotify({
                            show: true,
                            title: "Warning !",
                            msg: res.data.msg.toLowerCase().includes("maximum")
                              ? res.data.msg
                              : "Something went wrong. Please try again later.",
                          });
                        }
                      })
                      .catch((error) => {
                        setIsLoaded(false);
                        if (error.message.includes("403")) {
                          setShowNotify({
                            show: true,
                            title: "Warning !",
                            msg: "You have been logged-out due to inactivity. Login again.",
                            isUnAuth: true,
                          });
                        }
                      });
                  } else {
                    setShowNotify({
                      show: true,
                      title: "Warning !",
                      msg: "You have entered invalid branch name !",
                    });
                  }
                } else {
                  setShowNotify({
                    show: true,
                    title: "Warning !",
                    msg: "You have entered invalid college name !",
                  });
                }
              } else {
                setShowNotify({
                  show: true,
                  title: "Warning !",
                  msg: "You have entered an invalid email !",
                });
              }
            } else {
              setShowNotify({
                show: true,
                title: "Warning !",
                msg: "Email can't be blank !",
              });
            }
          } else {
            setShowNotify({
              show: true,
              title: "Warning !",
              msg: "Invalid lastname !",
            });
          }
        } else {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: "Invalid firstname !",
          });
        }
      } else {
        setShowNotify({
          show: true,
          title: "Warning !",
          msg: "Please enter your firstname",
        });
      }
    } else {
      setShowNotify({
        show: true,
        title: "Warning !",
        msg: "Please select the role",
      });
    }
    props.setAddUser(false);
  };

  const checkEmail = async (event, userInput = {}, checkExistEmail = {}) => {
    event.preventDefault();
    setFocusStates({ ...focusStates, [event.target.name]: false });
    const error = validators.email(checkExistEmail.email);
    if (error) {
      setShowNotify({
        show: true,
        title: "Warning",
        msg: error,
      });
      return;
    }
    try {
      setIsLoaded(true);
      const { data } = await axios.post(
        "node/admin/user/get",
        checkExistEmail,
        {
          headers: {
            "Content-type": "application/json",
          },
        },
      );

      if (data.resultCode === RESULT_STATUS.SUCCESS) {
        if (!data.data) {
          setSavebtnHide(true);
          setUserDetailByEmail([]);
          setIsExistingUser(false);
          return true;
        } else {
          setIsExistingUser(true);
          const existingUser = data.data;
          const targetRole = userInput.role;
          const isExistCompany = existingUser.isexistcompany;
          const loggedInRole = getDataFromStorage("role");
          const existingRoles = existingUser.roles
            ? existingUser.roles.split(",")
            : [];
          if (existingRoles.length) {
            for (const role of existingRoles) {
              if (
                constants.ROLE_CONFLICTS[targetRole]?.includes(role) ||
                constants.ROLE_CONFLICTS[role]?.includes(targetRole)
              ) {
                setShowNotify({
                  show: true,
                  msg: `This user is already assigned the role '${constants.Roles[role]}'. The role '${constants.Roles[targetRole]}' cannot be assigned due to role restrictions.`,
                  title: "Warning !",
                });
                return false;
              }
            }
            console.log("batchid", userInput.batchid, typeof userInput.batchid);

            if (isEdit) {
              if (existingUser.id === parseInt(userId)) {
                // Same email — just editing details
                setSavebtnHide(true);
                setUserDetailByEmail(existingUser);
                return true;
              }
              // Different email belongs to someone else — block
              setUserDetailByEmail(existingUser);
              setSavebtnHide(false);
              setShowNotify({
                show: true,
                msg: `This email already belongs to another user. You cannot update the user with this email.`,
                title: "Warning !",
              });
              return false;
            }

            if (isExistCompany) {
              if (existingRoles.includes(targetRole)) {
                if (existingUser.batchid === parseInt(userInput.batchid)) {
                  setUserDetailByEmail(existingUser);
                  setSavebtnHide(false);
                  setShowNotify({
                    show: true,
                    msg: `This user is already assigned the '${targetRole}' role in this batch. Cannot be add again.`,
                    title: "Warning !",
                  });
                  return false;
                } else if (
                  existingUser.batchid !== parseInt(userInput.batchid)
                ) {
                  setUserDetailByEmail(existingUser);
                  setSavebtnHide(true);
                  setShowNotify({
                    show: true,
                    msg: `This user is already assigned the '${targetRole}' role in some other batch. Click save button to add in this batch.`,
                    title: "Warning !",
                  });
                  return true;
                }
                setUserDetailByEmail(existingUser);
                setSavebtnHide(true);
                return true;
              } else {
                setUserDetailByEmail(existingUser);
                setSavebtnHide(false);
                setShowNotify({
                  show: true,
                  msg: `Unable to assign the '${targetRole}' role. This user is already assigned the '${existingRoles}' role in this account.`,
                  title: "Warning !",
                });
                return false;
              }
            }

            if (
              existingRoles.includes(targetRole) &&
              existingUser.batchid === parseInt(userInput.batchid)
            ) {
              setUserDetailByEmail(existingUser);
              setSavebtnHide(false);
              setShowNotify({
                show: true,
                msg: `This user is already assigned the '${targetRole}' role in this batch. Cannot be add again.`,
                title: "Warning !",
              });
              return false;
            } else if (
              existingRoles.includes(targetRole) &&
              existingUser.batchid !== parseInt(userInput.batchid)
            ) {
              setUserDetailByEmail(existingUser);
              setSavebtnHide(true);
              setShowNotify({
                show: true,
                msg: `This user is already assigned the '${targetRole}' role in some other batch. Click save button to add in this batch.`,
                title: "Warning !",
              });
              return true;
            }

            setUserDetailByEmail(existingUser);
            setSavebtnHide(true);
            return true;
          } else {
            setUserDetailByEmail(existingUser);
            setSavebtnHide(true);
            return true;
          }
        }
      } else if (data.resultCode === RESULT_STATUS.TECHNICAL_ERROR) {
        setShowNotify({
          show: true,
          title: "Error !",
          msg:
            data.message ??
            "Unable to validate the email. Please try again later",
        });
        return false;
      } else
        throw new Error("Unable to validate the email. Please try again later");
    } catch (error) {
      console.error("error..........", error);

      setShowNotify({
        show: true,
        isUnAuth: error.message.includes("403"),
        title: error.message.includes("403") ? "Warning !" : "Error !",
        msg: error.message.includes("403")
          ? "You have been logged-out due to inactivity. Login again."
          : "Unable to validate the email. Please try again later",
      });
      return false;
    } finally {
      setIsLoaded(false);
    }
  };

  const handleSave = () => {
    const form = new FormData();
    form.append("csv", batchDetails.csv);
    form.append("from", "uploadusersinsidebatch");
    form.append("batchid", batchDetails.id);
    form.append("firstname", batchDetails.firstname);
    form.append("lastname", batchDetails.lastname);
    form.append("email", batchDetails.email);
    form.append("mobile", batchDetails.mobile);
    form.append("college", batchDetails.college);
    form.append("branch", batchDetails.branch);
    if (props.newUserInput.hasOwnProperty("emailBody")) {
      form.append("emailBody", props.newUserInput.emailBody);
    } else {
      form.append("emailBody", batchDetails.emailBody);
    }

    // setOpenUploadUserModal(true);
    setIsLoaded(true);
    axios
      .post("node/admin/batch/userviacsv", form, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((response) => {
        setIsLoaded(false);
        if (response.data.resultCode === 1000) {
          setShowNotify({
            show: true,
            title: "Info",
            msg: response.data.msg,
          });
          // setUpdatedThumbnail(batchDetails.thumbnail);
          // setIsSuccess(true);
        } else if (response.data.resultCode === 2050) {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: response.data.msg,
          });
          // setIsSuccess(true);
        } else {
          setShowNotify({
            show: true,
            title: "Error !",
            msg: "Something went wrong. Please try again later.",
          });
        }

        // inputRef.current.value = "";

        if (response.data.hasOwnProperty("filedata")) {
          const url = window.URL.createObjectURL(
            new Blob([response.data.filedata]),
          );
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute(
            "download",
            `${new Date().toISOString().split("T")[0]}.csv`,
          );
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        console.log(error);
        const errResponse = error.response
        setIsLoaded(false);
        if (error.message.includes("403")) {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: "You have been logged-out due to inactivity. Login again.",
            isUnAuth: true,
          });
          return
        }
        if (error.response?.status === 504) {
          setShowNotify({
            show: true,
            title: "Info",
            msg: "Users are being added. Please check back after some time."
          });
          return
        }

        if (errResponse?.data?.hasOwnProperty("filedata")) {
          const url = window.URL.createObjectURL(
            new Blob([errResponse?.data?.filedata]),
          );
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute(
            "download",
            `${new Date().toISOString().split("T")[0]}.csv`,
          );
          document.body.appendChild(link);
          link.click();
        }
        setShowNotify({
          show: true,
          title: "Warning !",
          msg: errResponse?.data?.msg || "Unable to add the users. Please try again later.",
        });

        // inputRef.current.value = "";
      })
      .finally(() => {
        handleClosePopup();
        props.refetch();
      });
  };

  const handleUpdateUser = async (event) => {
    event.preventDefault();
    let emailid = document.uservalidateForm.email?.value?.trim();
    let lname = document.uservalidateForm.lastname?.value;
    let fname = document.uservalidateForm.firstname?.value;
    let college = document.uservalidateForm.college?.value;
    let branch = document.uservalidateForm.branch?.value;
    if (props.newUserInput?.role === constants.Roles.hr) {
      college = selectedCollege?.label;
      props.newUserInput.college = selectedCollege?.label;
    }
    let canUpdate = false;
    try {
      canUpdate = await checkEmail(event, props.newUserInput, checkExistEmail);
    } catch (error) {
      setShowNotify({
        show: true,
        isUnAuth: error.message.includes("403"),
        title: error.message.includes("403") ? "Warning !" : "Error !",
        msg: error.message.includes("403")
          ? "You have been logged-out due to inactivity. Login again."
          : "Unable to validate the email. Please try again later",
      });
      return;
    }
    if (canUpdate) {
      if (fname !== "") {
        if (/^[A-Za-z. ]+$/.test(fname)) {
          if (/^[A-Za-z. ]+$/.test(lname) || lname === "") {
            if (emailid !== "") {
              if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailid)) {
                if (
                  props.newUserInput.role === constants.Roles.hr &&
                  !selectedCollege?.label
                ) {
                  return setShowNotify({
                    show: true,
                    title: "Warning !",
                    msg: "Please select College !",
                  });
                }
                // if (/^[A-Za-z. ]+$/.test(college) || college === "")
                if (
                  /^[A-Za-z0-9.,&'’"()-/ ]+$/.test(college) ||
                  college === ""
                ) {
                  if (
                    /^[A-Za-z0-9.,&'’"()-/ ]+$/.test(branch) ||
                    branch === ""
                  ) {
                    setIsLoaded(true);
                    axios
                      .put(
                        "node/admin/batch/user",
                        JSON.stringify(props.newUserInput),
                        {
                          headers: {
                            "Content-type": "application/json",
                          },
                        },
                      )
                      .then((res) => {
                        setIsLoaded(false);

                        if (res.data.resultCode === 1000) {
                          setShowNotify({
                            show: true,
                            title: "Info",
                            msg: res.data.data,
                          });
                          props.setNewUserInput({});
                          handleClosePopup();
                          props.refetch();
                        } else if (res.data?.message?.code === "ER_DUP_ENTRY") {
                          setShowNotify({
                            show: true,
                            title: "Warning !",
                            msg: "This email has already exists",
                          });
                        } else {
                          setIsLoaded(false);
                          setShowNotify({
                            show: true,
                            title: "Error !",
                            msg: "Something Went Wrong",
                          });
                        }
                      })
                      .catch((error) => {
                        setIsLoaded(false);
                        if (error.message.includes("403")) {
                          setShowNotify({
                            show: true,
                            title: "Warning !",
                            msg: "You have been logged-out due to inactivity. Login again.",
                            isUnAuth: true,
                          });
                        }
                      });
                  } else {
                    setShowNotify({
                      show: true,
                      title: "Warning !",
                      msg: "You have entered invalid branch name !",
                    });
                  }
                } else {
                  setShowNotify({
                    show: true,
                    title: "Warning !",
                    msg: "You have entered invalid college name !",
                  });
                }
              } else {
                setShowNotify({
                  show: true,
                  title: "Warning !",
                  msg: "You have entered an invalid email !",
                });
              }
            } else {
              setShowNotify({
                show: true,
                title: "Warning !",
                msg: "Email can't be blank !",
              });
            }
          } else {
            setShowNotify({
              show: true,
              title: "Warning !",
              msg: "Invalid lastname",
            });
          }
        } else {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: "Invalid firstname",
          });
        }
      } else {
        setShowNotify({
          show: true,
          title: "Warning !",
          msg: "Please enter your firstname",
        });
      }
    }
  };

  const handleUploadUserfile = (event, file) => {
    if (!file.size) return;

    let reader = new FileReader();

    reader.onload = async (e) => {
      if (!e.target.result.includes("data:text/csv")) {
        setShowNotify({
          show: true,
          title: "Warning !",
          msg: "Wrong file type - CSV only.",
        });
      } else {
        setBatchDetails({
          ...batchDetails,
          csv: file,
          from: "uploadusersinsidebatch",
        });

        setFileLoaded(file.name);
        setSavebtnHide(true);
      }
    };

    reader.readAsDataURL(file);
  };

  const handleFileDownload = async (e) => {
    e.preventDefault();
    let URL = "";
    if (process.env.REACT_APP_DEPLOYMENT === "LOCAL")
      URL = "../../../assets/files/TEMPLATE_USER.csv";
    else {
      let data = await getPreSignedUrl(
        "Templates/TEMPLATE_USER.csv",
        undefined,
        "csv",
        "GET",
      );
      URL = data.url;
    }
    window.location.href = URL;
  };

  const handleFieldFocus = (name) => {
    setFocusStates({ ...focusStates, [name]: true });
  };

  const handleFieldBlur = (name) => {
    setFocusStates({ ...focusStates, [name]: false });
  };

  useEffect(() => {
    const getTopics = async () => {
      setIsLoaded(true);
      // const controller = new AbortController();
      try {
        let response = await axios.get(`node/admin/topic/get/${0}`, {
          headers: {
            "Content-type": "application/json",
          },
          // signal: controller.signal
        });
        setTopics(
          response.data?.data?.map((topic) => {
            return {
              label: topic.name,
              value: topic.id,
            };
          }),
        );
      } catch (error) {
        setShow(true);
        setTitle("Error");
        if (error.message.includes("403")) {
          setIsUnAuth(true);
          setMsg("You have been logged-out due to inactivity. Login again.");
        } else setMsg("Something went wrong. Please try again later.");
      } finally {
        setIsLoaded(false);
      }
      // controller.abort()
    };
    if (
      props.newUserInput.role === constants.Roles.tutor ||
      props.newUserInput.role === constants.Roles.creator
    )
      getTopics();
    // return () => getTopics();
  }, []);

  const handleRoleChange = (e) => {
    if (
      props.newUserInput.role === constants.Roles.trainer ||
      props.newUserInput.role === constants.Roles.tutor ||
      props.newUserInput.role === constants.Roles.evaluator
    ) {
      const newRole =
        e == "1"
          ? constants.Roles.tutor
          : e == "0"
            ? constants.Roles.trainer
            : constants.Roles.evaluator;
      setCheckExistEmail((prev) => ({
        ...prev,
        role: newRole,
      }));
      props.setNewUserInput((prev) => ({
        ...prev,
        role: newRole,
      }));
    } else if (e === constants.Roles.creator) {
      const newRole = constants.Roles.creator;
      setCheckExistEmail((prev) => ({
        ...prev,
        role: newRole,
      }));
      props.setNewUserInput((prev) => ({
        ...prev,
        role: newRole,
      }));
    } else if (e == constants.Roles.admin) {
      const newRole = constants.Roles.admin;
      setCheckExistEmail((prev) => ({
        ...prev,
        role: newRole,
      }));
      props.setNewUserInput((prev) => ({
        ...prev,
        role: newRole,
      }));
    }
  };

  const handleChangeCollegeFilter = (selectedOption) => {
    setSelectedCollege(selectedOption);
    // setSavebtnHide(true);
  };

  const roles = {
    learner: "Learner",
    trainer: "Trainer",
    tutor: "Tutor",
    evaluator: "Evaluator",
    creator: "Creator",
    admin: "Admin",
    hr: "TPO / HR",
    super_admin: "Super Admin",
  };

  return (
    <div>
      <Offcanvas
        placement="end"
        id="UserDetailsContainer"
        show={props.showUserFormPopup}
        onHide={handleClosePopup}
      >
        <div className="addUsersTitleSection">
          <p className="adduserTitle">
            {isNaN(parseInt(userId))
              ? `Add ${roles[props.newUserInput.role]}(s)`
              : `Edit ${roles[props.newUserInput.role]}`}
          </p>
        </div>
        {isNaN(parseInt(userId)) &&
          [
            constants.Roles.learner,
            constants.Roles.trainer,
            constants.Roles.tutor,
            constants.Roles.evaluator,
            constants.Roles.super_admin,
          ].includes(props.newUserInput.role) && (
            <div className="selectTypeOfadd">
              <Radio
                checked={selectedType === 0}
                value={0}
                size="md"
                text={
                  props.newUserInput.role !== constants.Roles.trainer &&
                    props.newUserInput.role !== constants.Roles.tutor &&
                    props.newUserInput.role !== constants.Roles.evaluator
                    ? "Single User"
                    : "Internal Trainer"
                }
                disabled={isEditTC && selectedType !== 0}
                onChange={(event) => {
                  if (props.newUserInput.role === constants.Roles.learner)
                    setAddSingleUser(true);
                  setSelectedType(0);
                  handleRoleChange(event);
                }}
              />
              <Radio
                checked={selectedType === 1}
                value={1}
                size="md"
                text={
                  props.newUserInput.role !== constants.Roles.trainer &&
                    props.newUserInput.role !== constants.Roles.tutor &&
                    props.newUserInput.role !== constants.Roles.evaluator
                    ? "Multiple users"
                    : "External Trainer"
                }
                disabled={isEditTC && selectedType !== 1}
                onChange={(event) => {
                  if (props.newUserInput.role === constants.Roles.learner)
                    setAddSingleUser(false);
                  setSelectedType(1);
                  handleRoleChange(event);
                }}
              />

              {[
                constants.Roles.trainer,
                constants.Roles.evaluator,
                constants.Roles.tutor,
              ].includes(props.newUserInput.role) && (
                  <Radio
                    checked={selectedType === 2}
                    value={2}
                    size="md"
                    text="Batch Evaluator"
                    disabled={isEditTC && selectedType !== 2}
                    onChange={(event) => {
                      setSelectedType(2);
                      handleRoleChange(event);
                    }}
                  />
                )}
            </div>
          )}
        {props.isCCFlow && isNaN(parseInt(userId)) && (
          <div className="selectTypeOfadd">
            <Radio
              checked={props.newUserInput.role === constants.Roles.creator}
              value="creator"
              size="md"
              text="Content Creator"
              onChange={(event) => {
                // props.setNewUserInput((prev) => ({ ...prev, role: constants.Roles.creator }));
                handleRoleChange(event);
              }}
            />
            <Radio
              checked={props.newUserInput.role === constants.Roles.admin}
              value="admin"
              size="md"
              text="Admin"
              onChange={(event) => {
                // props.setNewUserInput((prev) => ({ ...prev, role: constants.Roles.admin }));
                handleRoleChange(event);
              }}
            />
          </div>
        )}
        <div className="scrollableUserDetailsSection">
          <form className="addUserform" name="uservalidateForm">
            <div className="userDetails">
              {addSingleUser ? (
                <div className="inputFieldUserContainer">
                  <div className="emailContainer">
                    <TextField
                      label="Email ID"
                      id="usersEmail"
                      className="userFormField"
                      name="email"
                      variant="outlined"
                      size="small"
                      value={props.newUserInput?.email}
                      onChange={handleInputEmailChange}
                      onBlur={
                        !isEdit
                          ? (event) =>
                            checkEmail(
                              event,
                              props.newUserInput,
                              checkExistEmail,
                            )
                          : null
                      }
                      InputLabelProps={{
                        shrink:
                          focusStates["email"] ||
                          Boolean(props.newUserInput?.email),
                      }}
                      InputProps={{
                        onFocus: (event) => handleFieldFocus(event.target.name),
                      }}
                      fullWidth
                    />
                  </div>

                  <div className="nameContainer">
                    <TextField
                      label="First Name"
                      id="usersFirstname"
                      className="userFormField"
                      name="firstname"
                      variant="outlined"
                      size="small"
                      value={
                        isNaN(parseInt(userId)) && isExistingUser
                          ? userDetailByEmail?.firstname
                          : props.newUserInput?.firstname
                      }
                      onChange={(e) => handleInputChange(e)}
                      InputLabelProps={{
                        shrink:
                          focusStates["firstname"] ||
                          Boolean(
                            isNaN(parseInt(userId)) && isExistingUser
                              ? userDetailByEmail?.firstname
                              : props.newUserInput?.firstname,
                          ),
                      }}
                      InputProps={{
                        onFocus: (event) => handleFieldFocus(event.target.name),
                        onBlur: (event) => handleFieldBlur(event.target.name),
                      }}
                    />
                    <TextField
                      label="Last Name"
                      id="usersLastname"
                      className="userFormField"
                      name="lastname"
                      variant="outlined"
                      size="small"
                      value={
                        isNaN(parseInt(userId)) && isExistingUser
                          ? userDetailByEmail?.lastname
                          : props.newUserInput?.lastname
                      }
                      onChange={(e) => handleInputChange(e, "lastname")}
                      InputLabelProps={{
                        shrink:
                          focusStates["lastname"] ||
                          Boolean(
                            isNaN(parseInt(userId)) && isExistingUser
                              ? userDetailByEmail?.lastname
                              : props.newUserInput?.lastname,
                          ),
                      }}
                      InputProps={{
                        onFocus: (event) => handleFieldFocus(event.target.name),
                        onBlur: (event) => handleFieldBlur(event.target.name),
                      }}
                    />
                  </div>
                  <div className="phnContainer">
                    <PhoneInput
                      placeholder="Enter Number"
                      onlyCountries={["us", "in"]}
                      value={
                        isNaN(parseInt(userId)) && isExistingUser
                          ? userDetailByEmail?.mobile
                          : props.newUserInput?.mobile
                      }
                      onChange={(ph) => handleInputChange(ph, "mobile")}
                      countryCodeEditable={false}
                    />
                  </div>

                  {props.newUserInput.role === constants.Roles.hr && (
                    <>
                      <Select
                        className="companyPageDropdown"
                        isSearchable={true}
                        options={collegeList}
                        value={selectedCollege}
                        isMulti={false}
                        onChange={handleChangeCollegeFilter}
                        placeholder="Select College..."
                      />
                      {roleChangeInfo && !selectedCollege && (
                        <p className="rolechange_info">{roleChangeInfo}</p>
                      )}
                    </>
                  )}

                  {[constants.Roles.tutor, constants.Roles.creator].includes(
                    props.newUserInput.role,
                  ) && (
                      <>
                        <Select
                          isMulti
                          name="languages"
                          id="ccMultiSelect"
                          options={topics}
                          placeholder="Select Topic(s) to be shared"
                          classNamePrefix="select"
                          className="topicselectdropdown"
                          onChange={(e) => handleInputChange(e, "topic")}
                          components={{ ClearIndicator: () => null }}
                          value={topics.filter((topic) =>
                            props.newUserInput.topics?.some(
                              (selected) => selected.value === topic.value,
                            ),
                          )}
                          styles={{
                            menuList: (base) => ({
                              ...base,
                              textAlign: "left",
                              maxHeight: "170px",
                              overflowX: "hidden",
                              borderRadius: "2px",
                            }),
                          }}
                        />
                        {roleChangeInfo &&
                          !props.newUserInput?.topics?.length && (
                            <p className="rolechange_info">{roleChangeInfo}</p>
                          )}
                      </>
                    )}
                  {props.newUserInput.role === constants.Roles.learner ? (
                    <div className="branchndCollege">
                      <TextField
                        label="Branch"
                        id="usersBranch"
                        className="userFormField"
                        name="branch"
                        variant="outlined"
                        size="small"
                        value={
                          isNaN(parseInt(userId)) && isExistingUser
                            ? userDetailByEmail?.branch
                            : props.newUserInput?.branch
                        }
                        onChange={(e) => handleInputChange(e, "branch")}
                        InputLabelProps={{
                          shrink:
                            focusStates["branch"] ||
                            Boolean(
                              isNaN(parseInt(userId)) && isExistingUser
                                ? userDetailByEmail?.branch
                                : props.newUserInput?.branch,
                            ),
                        }}
                        InputProps={{
                          onFocus: (event) =>
                            handleFieldFocus(event.target.name),
                          onBlur: (event) => handleFieldBlur(event.target.name),
                        }}
                      />
                      <TextField
                        label="College"
                        id="usersCollege"
                        className="userFormField"
                        name="college"
                        variant="outlined"
                        size="small"
                        value={
                          isNaN(parseInt(userId)) && isExistingUser
                            ? userDetailByEmail?.college
                            : props.newUserInput?.college
                        }
                        onChange={(e) => handleInputChange(e, "college")}
                        InputLabelProps={{
                          shrink:
                            focusStates["college"] ||
                            Boolean(
                              isNaN(parseInt(userId)) && isExistingUser
                                ? userDetailByEmail?.college
                                : props.newUserInput?.college,
                            ),
                        }}
                        InputProps={{
                          onFocus: (event) =>
                            handleFieldFocus(event.target.name),
                          onBlur: (event) => handleFieldBlur(event.target.name),
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="multiuploadbtnContainer">
                  {fileLoaded === "" ? (
                    <Button
                      size={"lg"}
                      onClick={handleFileUpload}
                      disable={false}
                      icon={{
                        type: "leading",
                        icon: <UploadSvg stroke="#ffffff" />,
                      }}
                      hierarchy={{
                        type: "primary",
                        buttonText: "Upload Student List",
                      }}
                    />
                  ) : (
                    <Button
                      size={"lg"}
                      onClick={handleFileUpload}
                      disable={false}
                      icon={{
                        type: "leading",
                        icon: <UploadSvg stroke="#ffffff" />,
                      }}
                      hierarchy={{
                        type: "secondaryColor",
                        buttonText: fileLoaded,
                      }}
                    />
                  )}

                  <input
                    type="file"
                    name="myfile"
                    className="uploadUserstFileInput"
                    style={{ width: "150px", height: "30px" }}
                    accept=".csv"
                    onChange={(event) =>
                      handleUploadUserfile(event, event.target.files[0])
                    }
                  />
                  <Button
                    size={"lg"}
                    onClick={handleFileDownload}
                    disable={false}
                    icon={{
                      type: "leading",
                      icon: (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M5.83333 8.33333L10 12.5M10 12.5L14.1667 8.33333M10 12.5V2.5"
                            stroke="#344054"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ),
                    }}
                    hierarchy={{
                      type: "secondaryGrey",
                      buttonText: "Download Template",
                    }}
                  />
                </div>
              )}

              {isNaN(parseInt(userId)) ? (
                <Form.Group className="mb-3 mt-3">
                  <Editor
                    tinymceScriptSrc="/tinymce/tinymce.min.js"
                    textareaName="emailBody"
                    value={props.newUserInput.emailBody}
                    onEditorChange={(event) =>
                      handleInputChange(event, "emailBody")
                    }
                    init={{
                      license_key: "gpl",
                      minHeight: 1200,
                      menubar: false,
                      branding: false,
                      statusbar: false,
                      elementpath: false,
                      selector: "textarea",
                      allow_html_in_named_anchor: true,
                      plugins: [
                        "code",
                        "help",
                        "lists",
                        "media",
                        "table",
                        "anchor",
                        "charmap",
                        "preview",
                        "advlist",
                        "wordcount",
                        "fullscreen",
                        "autoresize",
                        "visualblocks",
                        "searchreplace",
                        "insertdatetime",
                      ],
                      toolbar:
                        "undo redo | blocks | " +
                        "bold italic underline forecolor  | alignleft aligncenter " +
                        "alignright alignjustify | bullist numlist outdent indent | " +
                        "removeformat | help |",
                      content_style:
                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    }}
                  />
                </Form.Group>
              ) : null}
            </div>
            <div></div>
          </form>
        </div>
        <div className="buttonContainerUserdetails">
          {isNaN(parseInt(userId)) ? (
            <Button
              size={"sm"}
              onClick={
                addSingleUser ||
                  [
                    constants.Roles.trainer,
                    constants.Roles.tutor,
                    constants.Roles.creator,
                    constants.Roles.evaluator,
                    constants.Roles.super_admin,
                  ].includes(props.newUserInput.role)
                  ? handleCreateUser
                  : handleSave
              }
              disable={!savebtnHide}
              hierarchy={{
                type: "primary",
                buttonText: "Save",
              }}
            />
          ) : (
            <Button
              size={"sm"}
              onClick={handleUpdateUser}
              disable={
                !props.newUserInput?.email ||
                !props.newUserInput?.firstname ||
                !savebtnHide
              }
              hierarchy={{
                type: "primary",
                buttonText: "Update",
              }}
            />
          )}
          <Button
            size={"sm"}
            onClick={handleClosePopup}
            disable={false}
            hierarchy={{
              type: "secondaryGrey",
              buttonText: "Cancel",
            }}
          />
        </div>
      </Offcanvas>
    </div>
  );
}

export default UserDetails;
